// Import dependencies
import './index.scss';

// Functions calls
dropdownMenu();

/**
 * Generates the dropdown menu functionality.
 */
function dropdownMenu() {
    let dropdown = document.querySelector( '.primary-menu' ), //ul
        ul = document.querySelector( '.mobile-menu ul' ),
        buttonClick = document.querySelector( '.check-button' ), //button
        hamburger = document.querySelector( '.menu-icon' ),
        hero = document.querySelector( '.hero' ).offsetHeight,
        mobileMenu = document.querySelector( '.mobile-menu' );

    buttonClick.addEventListener( 'click', () => {
        mobileMenu.classList.toggle( 'show-dropdown' );
        mobileMenu.style.height = hero + 'px';
        hamburger.classList.toggle( 'animate-button' );
    } );
}
